const {resetPassword, sendResetEmail, signIn, signInUserToken, validatePasswordResetToken, SendOtpService} = require('../../services/LoginService');
const {getAllUsers, getUsersForClient, getUserById} = require('../../services/UserService');

export default {
  namespaced: true,
  state: {
    userList: null,
    user: null,
    isSignedIn: false,
    isValidToken: null,
    isPasswordReset: false,
    token: null,
    userToEdit: null,
    initialUser: null,
    isAdminEmailCheck: 0
  },
  getters: {
    isAdmin: (state) => {
      return state.user && state.user.isAdmin;
    },
    isSuperAdmin: (state) => {
      return state.user && state.user.isSuperAdmin;
    },
    isAdminEmailCheck: (state) => {
      return state.isAdminEmailCheck;
    },
    clientId: (state) => {
      return state.user && state.user.clientId ? state.user.clientId : null;
    },
    currentUser: (state) => {
      return state.user;
    },
    isValidToken: (state) => {
      return state.isValidToken;
    },
    isPasswordReset: (state) => {
      return state.isPasswordReset;
    },
    getToken: (state) => {
      return state.token;
    },
    userList: (state) => {
      return state.userList;
    },
    isSignedIn: (state) => {
      return state.isSignedIn;
    },
    userToEdit: (state) => {
      return state.userToEdit;
    },
    initialUser: (state) => {
      return state.initialUser;
    },
    userEdited: (state) => {
      if (state.userToEdit) {
        for (let key of Object.keys(state.userToEdit)) {
          if (key === 'email' || key === 'directPhone' || key === 'officePhone') {
            let editValue = state.userToEdit[key] ? String(state.userToEdit[key]).toLowerCase() : '';
            let initialValue = state.initialUser[key] ? String(state.initialUser[key]).toLowerCase() : '';
            if (editValue !== initialValue) {
              return true;
            }
          }
        }
      }
      return false;
    }
  },
  mutations: {
    signIn (state, user) {
      state.user = user;
      state.isAdmin = user.isAdmin === 1;
      state.isSignedIn = true;
    },
    signInEmailId (state, user) {
      state.isAdminEmailCheck = 1;
    },
    updateUserClient (state, user) {
      state.user = user;
    },
    setIsValidToken (state, isValid) {
      state.isValidToken = isValid;
    },
    setIsPasswordReset (state, isReset) {
      state.isPasswordReset = isReset;
    },
    setToken (state, token) {
      state.token = token;
    },
    setUserList (state, userList) {
      state.userList = userList;
    },
    signOut (state) {
      state.user = null;
      state.isAdmin = false;
      state.isSignedIn = false;
    },
    setUserToEdit (state, user) {
      state.userToEdit = Object.assign({}, user);
      state.initialUser = Object.assign({}, user);
    },
    updateUserProfile (state, user) {
      state.user = user;
    },
    removeCurrentUserToken (state) {
      state.user.access_token = null;
    },
    removeCurrentEmailIdCheck (state) {
      state.isAdminEmailCheck = 0;
    }
  },
  actions: {
    async signInUser ({commit}, data) {
      try {
        commit('removeCurrentEmailIdCheck');
        const user = await signIn(data.email, data.password);
        if (user.data !== 'Incorrect password.') {
        }
        if (user.data === 'No matching user found.') {
          commit('signInEmailId', user.data);
        } else {
          commit('signIn', user.data);
        }
      } catch (error) {
        console.error('Could not sign user in.', error);
        throw error;
      }
    },
    async signInUserToken ({commit}, data) {
      try {
        const user = await signInUserToken(data);
        if (user.data.length !== 0) {
          console.log('User ' + user.data[0].email + ' signed in successfully.');
        }
        if (user.data.length) {
          commit('signIn', user.data[0]);
        }
        return user;
      } catch (error) {
        console.error('Could not sign user in.', error);
        throw error;
      }
    },
    async SendOtpModal ({commit}, data) {
      try {
        const user = await SendOtpService(data);
        return user;
      } catch (error) {
        console.error('Could not sign user in.', error);
        throw error;
      }
    },
    async updateUserClientData ({commit}, data) {
      try {
        const user = await getUserById(data.id);
        commit('updateUserClient', user.data);
      } catch (error) {
        console.error('Could not sign user in.', error);
        throw error;
      }
    },
    async sendResetPasswordEmail ({commit}, data) {
      try {
        await sendResetEmail(data);
      } catch (error) {
        console.log(error);
        throw error;
      }
    },
    async validateToken ({commit}, token) {
      try {
        const isValid = await validatePasswordResetToken(token);
        commit('setIsValidToken', isValid.data);
        commit('setToken', token);
      } catch (error) {
        commit('setIsValidToken', error.response.data);
        throw error;
      }
    },
    async resetUserPassword ({commit}, data) {
      try {
        const passwordReset = await resetPassword(data.password, data.token);
        commit('setIsPasswordReset', passwordReset.data);
      } catch (error) {
        throw error;
      }
    },
    async loadUserList ({commit}, clientId = null) {
      try {
        let userList = null;
        if (clientId) {
          const clientUsers = await getUsersForClient(clientId);
          userList = clientUsers.data;
        } else {
          const allUsers = await getAllUsers();
          userList = allUsers.data;
        }
        commit('setUserList', userList);
      } catch (error) {
        console.log(error);
        throw error;
      }
    },
    clearUserList ({commit}) {
      commit('setUserList', null);
    },
    signOutUser ({commit}) {
      commit('signOut');
    },
    setUserToEdit ({commit}, user) {
      commit('setUserToEdit', user);
    },
    clearUserToEdit ({commit}) {
      commit('setUserToEdit', null);
    },
    updateUserProfile ({commit}, user) {
      commit('updateUserProfile', user);
    },
    cleanTokenFromCurrentUser ({commit}) {
      commit('removeCurrentUserToken');
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/userModule.js